<template>
  <div class="reviews-analyst-widget">
    <subtitle-component>
      <span class="mr-2">
        {{ $t("message.reviews.analyst.subtitleSummary") }}
      </span>
      <TooltipIcon>
        {{ $t("message.reviews.analyst.subtitleSummaryTooltip") }}
      </TooltipIcon>
    </subtitle-component>
    <v-card class="card-container">
      <template v-if="stats && stats.count">
        <v-card class="avg-rating" color="primary" elevation="0" dark>
          <div class="card-label">
            {{ $t("message.reviews.analyst.averageRating") }}
          </div>

          <div class="card-value">
            {{ stats.avg_rating }}
          </div>

          <StarsRating :rating="stats.avg_rating" />

          <TooltipIcon :custom-style="tooltipStyle" color="light">
            {{ $t("message.reviews.analyst.averageRatingTooltip") }}
          </TooltipIcon>
        </v-card>

        <v-card class="total-ratings" elevation="0">
          <div class="card-label">
            {{ $t("message.reviews.analyst.totalRatingCount") }}
          </div>

          <div class="card-value">
            {{ stats.count | number }}
          </div>

          <TooltipIcon :custom-style="tooltipStyle">
            {{ $t("message.reviews.analyst.totalRatingCountTooltip") }}
          </TooltipIcon>
        </v-card>
      </template>
      <NoData
        :fill="true"
        :description="$t('message.reviews.analyst.noDataDescription')"
        v-else
      ></NoData>
      <SectionLoader :status="loading" :opacity="1" />
    </v-card>
  </div>
</template>

<script>
import SubtitleComponent from "@/components/ui/Subtitle/Subtitle.component.vue";
import SectionLoader from "@/components/Loader/SectionLoader";
import NoData from "@/components/ui/NoData";
import TooltipIcon from "@/components/ui/TooltipIcon";
import StarsRating from "@/components/ui/StarsRating";

export default {
  name: "ReviewsAnalystSummary",
  components: {
    SubtitleComponent,
    SectionLoader,
    NoData,
    TooltipIcon,
    StarsRating
  },
  props: {
    stats: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      tooltipStyle: {
        position: "absolute",
        right: "11px",
        top: "11px"
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.reviews-analyst-widget {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.card-container {
  flex: 1;
  padding: 52px 38px;
  font-family: $font-family-base;

  > .v-card {
    padding: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 132px;
    position: relative;
    border-radius: 4px !important;
    filter: none !important;
  }

  .card-label {
    @include font-size(16px);
    opacity: 0.7;
    text-align: center;
    letter-spacing: -0.02em;
  }

  .card-value {
    @include font-size(35px);
    font-weight: bold;
    text-align: center;
    line-height: 49px;
    letter-spacing: 0.01em;
  }
}

.avg-rating {
  margin-bottom: $spacing * 1.25;
  background: linear-gradient(
    96.23deg,
    $avg-rating-gradient-first-color -1.59%,
    $avg-rating-gradient-second-color 100%
  );
  border: 1px solid $cyan !important;
}

.total-ratings {
  background: $total-rating-bg-color;
  color: $grey-darker;
}
</style>
